import styled from 'styled-components';

export const Wrapper = styled.div`
  z-index: 98;
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  position: relative;

  & > ul {
    position: absolute;
    right: 0;
    top: 30px;
    background: #fff;
    font-size: 14px;
    border: 1px solid #dbe1e9;
    border-radius: 4px;
    box-shadow: 0px 0px 2px #00000026;
    min-width: 180px;

    & > li {
      display: flex;
      color: #444;
      align-items: center;
      margin: 0 10px;
      padding: 10px 5px;
      transition: background 0.3s;

      &:not(:last-child) {
        border-bottom: 1px solid #dbe1e9;
      }

      svg {
        margin-right: 5px;
      }

      button {
        flex: 1;
        display: flex;
        align-items: center;
        text-align: left;
        border: 0;
        padding: 0 2px;
        background: none;
        color: #444;
      }
    }
  }
`;
